module.exports = __webpack_public_path__ + "media/images/light_grey_5_line_dots-6bccc6d3fc57aa304177c0ce2790867b.svg";